import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";

const FeedbackForm = () => (
  <Box sx={{ p:4 }}>
    <Typography variant="h4" fontWeight={700} mb={3}>Feedback</Typography>
    {/* Category dropdown, Stars, Comments */}
  </Box>
);
export default FeedbackForm;
